// removed by extract-text-webpack-plugin
module.exports = {"loginPage":"_29OrYvfMUhaO3hHqqWg6A_"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.scss
// module id = 835
// module chunks = 0